module.exports = __webpack_public_path__ + "img/yb-logo.60bf70be.png";